import { gql } from '@apollo/client';

export const GET_TMS_VEHICLES_WITH_MODEL = gql`
    query GetTmsVehiclesWithModel($carrierId: Int, $status: Int, $routeType: Int) {
        getTmsVehiclesWithModel(carrierId: $carrierId, status: $status, routeType: $routeType) {
            id
            vehicleModelId
            licensePlate
            vehicleModelName
            vehicleTypeId
            vehicleTypeName
        }
    }
`;

export const GET_TMS_VEHICLES_BY_WAREHOUSE_ID_FOR_SELECT = gql`
    query GetTmsVehiclesByWarehouseIdForSelect($warehouseId: Long!, $status: Int, $routeType: Int) {
        getTmsVehiclesByWarehouseIdForSelect(warehouseId: $warehouseId, status: $status, routeType: $routeType) {
            id
            vehicleModelId
            licensePlate
            vehicleModelName
            vehicleTypeId
            vehicleTypeName
        }
    }
`;

export interface TmsVehicleWithModelType {
    id: number;
    vehicleModelId: number;
    licensePlate: string;
    vehicleModelName?: string;
    vehicleTypeId?: number;
    vehicleTypeName?: string;
}

export interface TmsVehiclesWithModelResponse {
    getTmsVehiclesWithModel: TmsVehicleWithModelType[];
}

export interface GetTmsVehiclesByWarehouseIdForSelectVariables {
    warehouseId: number;
    status?: number;
    routeType?: number;
}

export interface GetTmsVehiclesByWarehouseIdForSelectResponse {
    getTmsVehiclesByWarehouseIdForSelect: TmsVehicleWithModelType[];
}

